// extracted by mini-css-extract-plugin
module.exports = {"attachButton":"styles_attachButton__2rQpH","attachSection":"styles_attachSection__1cs3Q","select":"styles_select__3sMDN"};